import styled, { css } from 'styled-components';

// *** Base ***
const baseToolTip = css`
  align-items: center;
  display: flex;
`;

// *** Components ***
const ToolTip = styled.div`
  ${baseToolTip}
`;

export const Styled = {
  ToolTip,
};
